import { render, staticRenderFns } from "./WxList.vue?vue&type=template&id=2c33f97a&scoped=true&"
import script from "./WxList.vue?vue&type=script&lang=js&"
export * from "./WxList.vue?vue&type=script&lang=js&"
import style0 from "./WxList.vue?vue&type=style&index=0&id=2c33f97a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c33f97a",
  null
  
)

export default component.exports